<template>
  <default>
    <div class="text-center">
<!--      ADRESA-->
      <h1>Zadat novou objednávku</h1>
      <div class="" v-if="customer?.addresses?.shipping && customer?.addresses?.billing">
        <p>Zboží bude doručeno na adresu:</p>
        <strong>
          {{ customer?.addresses?.shipping?.company }}<br/>
          <template v-if="customer?.addresses?.shipping?.custom?.nazevd">
            {{ customer.addresses.shipping.custom.nazevd }}<br/>
          </template>
          <template v-else>
            {{ customer?.addresses?.shipping?.street }}<br/>
            {{ customer?.addresses?.shipping?.zip }} {{ customer?.addresses?.shipping?.city }}<br/>
          </template>
        </strong>
        <br/>
        <p>Pokud adresa nesouhlasí, tak nás kontaktujte na emailu <a href="mailto:webmaster@girafruit.cz">webmaster@girafruit.cz</a>
        </p>
      </div>
      <div class="col-10 ms-auto me-auto" v-else>
        <span class="">Vyberte hlavní dodací adresu pro Vaši firmu:</span> <br/>
        <address-select class=""/>
        <div class="alert alert-danger">
          <strong>POZOR:</strong> Po objednání se tato adresa spráruje s Vaším účtem a nebude již možné v objednávkovém
          formuláři tuto adresu změnit.
          V případě, že zde nevidíte správnou adresu pro výběr, tak nás kontaktujte na emailu <strong><a
            href="mailto:webmaster@girafruit.cz">webmaster@girafruit.cz</a></strong>
        </div>
      </div>
<!--      FORMULÁŘ-->
      <order-form v-if="customer?.addresses?.shipping"/>
    </div>
  </default>
</template>

<script lang="ts">
import {useAppStore} from "@/stores/appStore";
import AddressSelect from "@/components/gira/addressSelect.vue";
import Default from "@/layouts/default.vue";
import OrderForm from "@/components/gira/orderForm.vue";

export default {
  components: {OrderForm, Default, AddressSelect},
  data() {
    return {
      appStore: useAppStore(),
    };
  },
  computed: {
    customer() {
      return this.appStore.customer;
    },
  },
};
</script>
